import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledLegendContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
}));

export const StyledLegend = styled(Box)(({ theme }) => ({
  width: '11px',
  height: '11px',
  borderRadius: '2px',
  border: `1px solid ${theme.palette.divider}`,
}));
